import React, { useState } from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Drawer, Flex, Form, Input, Typography } from "@payping/web-components";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { DashboardRoutes } from "@/router/constant";
import { useBusinessDisabled } from "@/mobile/Settings/Business/Edit/utils/useBusinessDisabled";
import { useHandleNavigationURL, useSaveToRedux } from "../utils";
import { settingsBusinessAtom } from "../../state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsBusinessAtom, (val) => val.mobileFormEdit);

const MobileEditBusinessName: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const { t } = useAppTranslation();
  const [form] = Form.useForm();
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const businessNameApi = useAppSelector((state) => state.user.businessInfo?.businessName);
  const isBusinessDisabled = useBusinessDisabled();

  // Custom Hooks
  const { saveToRedux } = useSaveToRedux();
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        placement={"bottom"}
        open={isDrawerOpen}
        height={"100%"}
        title={`${t("edit")} / ${t("name")}`}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Flex vertical>
          <Form
            onFinish={({ businessName }) =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditBusiness.description.url,
                fieldName: "businessName",
                fieldValue: businessName,
                setIsDrawerOpen,
              })
            }
            form={form}
            initialValues={{ businessName: mobileFormEditState.businessName ?? businessNameApi }}
          >
            <Form.Item label={t("businessName")} name="businessName">
              <Input disabled={isBusinessDisabled} />
            </Form.Item>
          </Form>
          <Typography.Text type={"secondary"}>{t("settings.business.instructions.businessName")}</Typography.Text>
        </Flex>
      </Drawer>
      <EditActionButtons onAccept={form.submit} />
    </>
  );
};

export default MobileEditBusinessName;
